import React, { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./navbar.css";
import { auth, db } from "../../firebase";
import { signOut } from "firebase/auth";
import { updateDoc, doc } from "firebase/firestore";
import { AuthContext } from "../../Context/UseAuthContext";

const Navbar = () => {
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);

  const handleSignout = async () => {
    await updateDoc(doc(db, "users", auth.currentUser.uid), {
      isOnline: false,
    });
    await signOut(auth);
    navigate("/login");
  };

  return (
    <nav className="navbar">
      <h1 onClick={() => navigate("/")}>ChatUP</h1>

      <div className="navbar-links">
        {user ? (
          <div className="loggedin-links">
            <li>
              <Link to="/profile">Profile</Link>
            </li>
            <button className="logout-btn" onClick={handleSignout}>
              Logout
            </button>
          </div>
        ) : (
          <>
            <li>
              <Link to="/register">Register</Link>
            </li>
            <li>
              <Link to="/login">Login</Link>
            </li>
          </>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
